<template>
  <b-table :items="produits" :fields="fields" foot-clone>
    <template v-slot:cell(Supp)="row">
      <!-- Bouton de suppression -->
      <b-button
        variant="link"
        size="sm"
        class="mb-2"
        @click="deleteProduit(row.item)"
      >
        <b-icon icon="trash" scale="2"></b-icon>
      </b-button>
    </template>
    <template v-slot:foot(libellé)>
      <i>Total :</i>
    </template>
    <template v-slot:foot(qté)>
      <i></i>
    </template>
    <template v-slot:foot(prix)>
      <i></i>
    </template>
    <template v-slot:foot(montant)>
      <i>{{ montantTotal }}</i>
    </template>
  </b-table>
</template> 

<script>
const euro = new Intl.NumberFormat("fr-FR", {
  style: "currency",
  currency: "EUR",
  minimumFractionDigits: 2,
});
export default {
  computed: {
    montantTotal() {
      var Total = 0;
      if (this.produits.length > 0) {
        Total = parseFloat(this.produits[0].montantFloat).toFixed(2);
      }
      if (this.produits.length > 1) {
        for (let i = 1; i < this.produits.length; i++) {
          Total = (
            parseFloat(Total) + parseFloat(this.produits[i].montantFloat)
          ).toFixed(2);
        }
      }
      
      return euro.format(Total);
    },
  },
  data() {
    return {
      fields: [
        {
          key: "idProduit",
          thClass: "d-none",
          tdClass: "d-none",
        },
        {
          key: "libellé",
          label: "Article",
        },
        {
          key: "qté",
          label: "Qté",
        },
        {
          key: "prix",
          label: "Prix",
        },
        {
          key: "montant",
          label: "Montant",
        },
        {
          key: "Supp",
          label: "",
        },
      ],
      produits: [],
    };
  },
  mounted() {
    this.initListeProduits();
  },
  methods: {
    dynamicSort(property) {
      var sortOrder = 1;

      if (property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
      }

      return function (a, b) {
        if (sortOrder == -1) {
          return b[property].localeCompare(a[property]);
        } else {
          return a[property].localeCompare(b[property]);
        }
      };
    },

    initListeProduits() {
      this.produits.length = 0;
      for (let i = 0; i < this.$store.state.panierEnCours.length; i++) {
        this.produits.push({
          idProduit: this.$store.state.panierEnCours[i].idProduit,
          libellé: this.$store.state.panierEnCours[i].libellé,
          qté:
            this.$store.state.panierEnCours[i].qté +
            " " +
            this.$store.state.panierEnCours[i].unité,
          prix: euro.format(this.$store.state.panierEnCours[i].prix),
          montant: euro.format(this.$store.state.panierEnCours[i].montant),
          montantFloat: this.$store.state.panierEnCours[i].montant
        });
      }
      this.produits.sort(this.dynamicSort("libellé"));
    },
    deleteProduit(item) {
      this.$bvModal
        .msgBoxConfirm("Voulez-vous retirer l'article " + item.libellé + " ?", {
          okTitle: "Supprimer",
          cancelTitle: "Annuler",
        })
        .then((value) => {
          if (value === true) {
            this.$store.commit({
              type: "removeProduit",
              idProduit: item.idProduit,
            });
            this.initListeProduits();
          }
        });
    },
  },
};
</script>